import { render } from "./Blank.vue?vue&type=template&id=bbf5e182"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"

import exportComponent from "/home/omni/repo/alumni-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__